import { render, staticRenderFns } from "./EditCurtain.vue?vue&type=template&id=713489d4&scoped=true&"
import script from "./EditCurtain.vue?vue&type=script&lang=js&"
export * from "./EditCurtain.vue?vue&type=script&lang=js&"
import style0 from "./EditCurtain.vue?vue&type=style&index=0&id=713489d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713489d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDivider,VForm,VRow,VStepperContent,VTextField})
